module.exports = __webpack_public_path__ + "img/11d.7a052770.svg";